import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';


import { MaterialDesignModule } from '../../shared/material-design/material-design.module';
import { SharedModule } from '../../shared/shared.module';

import { MaterialsService } from '../../shared/materials.service';
import { ManageMaterialsComponent } from './manage-materials.component';
import { ModifyMaterialComponent } from './modify-material.component';

@NgModule({
  imports: [ CommonModule, FormsModule, ReactiveFormsModule, MaterialDesignModule, SharedModule],
  declarations: [ ManageMaterialsComponent, ModifyMaterialComponent ],
  providers: [ MaterialsService ],
  entryComponents: [ ModifyMaterialComponent ],
})

export class ManageMaterialsModule {}



// WEBPACK FOOTER //
// /app/src/app/hq/materials/manage-materials.module.ts